__webpack_require__.p = "https://static.bigbrain.gg/wow/build/";